import React from 'react'
import BudgetOverview from 'src/app/BudgetOverview/BudgetOverview'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { budgetOverviewRouteProps } from 'src/navigation/routeProps'

const BudgetOverviewAppRoute: AppRoute = {
  id: AppLocation.BudgetOverview,
  routeProps: budgetOverviewRouteProps,
  component: <BudgetOverview />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default BudgetOverviewAppRoute
